import React, { useState, useEffect } from 'react'
import { Fragment } from 'react'


import axios from "axios";
import { Dialog, Transition } from "@headlessui/react";
import {
  XMarkIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/20/solid";
import { toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";


import { Pagination } from "../../helper/HelperTwo";
import ActivePlanCreate from './ActivePlanCreate';
import ActivePlanEdit from "./ActivePlanEdit"
import Loader from '../../../utils/Loader';
import ActivePlanView from './ActivePlanView';

const ActivePlanList = () => {

  const [formData, setFormData] = useState([])
  const [activePlanCreateOpen, setActivePlanCreateOpen] = useState(false)
  const [activePlanEditOpen, setActivePlanEditOpen] = useState(false)
  const [activePlanViewOpen, setActivePlanViewOpen] = useState(false)
  const [paginationData, setPaginationData] = useState(null);

  const [activePlanId, setActivePlanID] = useState("")
  const [activePlanDelete, setActivePlanDelete] = useState(false)
  const [loading, setLoading] = useState(true)
  const [deleteMsg, setDeleteMsg] = useState(
    "Are you sure you want to delete the Active Plan ?"
  );
  const navigate = useNavigate();
  const [error, setError] = useState(null)

  const handleClick = () => {
    setActivePlanCreateOpen(true);
  };

  const handleClose = () => {
    setActivePlanCreateOpen(false);
    setActivePlanEditOpen(false)
    setActivePlanViewOpen(false)

    fetch()
  }

  const fetch = async () => {
    setLoading(true)
    try {
      const token = localStorage.getItem("token");
      let endpoint = `public/api/active/plans`;
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      if (response.data.success) {
        setFormData(response.data.active_plans.data)
        setPaginationData(response.data.active_plans)
      }


    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm");
      }

      setError(" Please check your internet connection and try again.")
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    fetch()
  }, [])

  const handlePageChange = (page) => {
    if (page !== "...") {
      fetch(page);
    }
  };

  const handleClickForEdit = (id) => {
    setActivePlanID(id);
    setActivePlanEditOpen(true);
  };

    const handleClickForView = (id) => {
    setActivePlanID(id);
    setActivePlanViewOpen(true);
  };
  const Delete = (id_crypt) => {
    setActivePlanDelete(true);
    setActivePlanID(id_crypt);
  };

  const handleClickForDelete = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.delete(
        `public/api/active/plans/${activePlanId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      if (response.data) {
        toast.success(" Deleted successfully!");
        fetch()
        setActivePlanDelete(false)

      }


    } catch (error) {
      if (error.response.status === 401) {
        localStorage.removeItem("token");
        navigate("/");
      }
      setError(error.response.data.messaage || " Please check your internet connection and try again.")
    }
  }
  if (loading) {
    return (
      <Loader />
    )
  }

  if (error) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
        <div className="bg-white rounded-lg shadow-lg p-8 max-w-md">
          <div className="flex items-center justify-center mb-6">
            <svg
              className="h-12 w-12 text-red-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>

          <p className="text-gray-600 mb-8 text-center">
            Please check your internet connection and try again.
          </p>
          <div className="flex justify-center">
            <button
              className="bg-[#0f172a] hover:bg-teal-900 text-white font-semibold py-2 px-4 rounded transition duration-300"
              onClick={() => window.location.reload()}

            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    )

  }

  return (
    <div>
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="font-semibold text-3xl text-gray-900">Active Plan</h1>
            <p className="mt-2 text-sm text-gray-700">
              Active Plan all your chit fund Customer and their details..
            </p>
          </div>
          <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
            <button
              type="button"
              onClick={handleClick}
              className="block rounded-md bg-[#0f172a] px-3 py-2 text-center text-sm font-semibold text-white shadow-xs hover:bg-teal-900 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Active Plan
            </button>
          </div>
        </div>
        <div className="mt-8 flow-root">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 border rounded-md align-middle sm:px-6 lg:px-8">
              <div className="overflow-hidden shadow-sm  sm:rounded-lg">
                <table className="min-w-full divide-y  divide-gray-300 shadow-xl">
                  <thead className="text-white  bg-[#0f172a]">
                    <tr>
                      <th scope="col" className="py-3.5 pr-3 pl-4 text-left text-sm font-semibold  sm:pl-6">
                        #
                      </th>
                      <th scope="col" className="py-3.5 pr-3 pl-4 text-left text-sm font-semibold  sm:pl-6">
                        Plan Name
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                        Group Name
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                        Start Data
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                        End Data
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                        status
                      </th>

                      <th scope="col" className="relative py-3.5 pr-4 pl-3 sm:pr-6">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">

                    {formData?.map((person, index) => (
                      <tr key={index}
                        className='hover:bg-gray-50'
                      >
                        <td className="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-6">
                          {index + 1}
                        </td>
                        <td className="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-6">
                          {person.plan.name}
                        </td>
                        <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-500">
                          {person.group.group_name}</td>
                        <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-500">
                          {person.start_date}

                        </td>

                        <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-500">
                          {person.end_date}</td>
                        <td className="px-3 py-4 text-sm whitespace-nowrap">
                          {person.status === "active" ? (
                            <span className="inline-flex items-center px-2 py-1 text-xs font-medium text-green-700 bg-green-100 rounded-full">
                              Active
                            </span>
                          ) : (
                            <span className="inline-flex items-center px-2 py-1 text-xs font-medium text-red-700 bg-red-100 rounded-full">
                              Inactive
                            </span>
                          )}
                        </td>


                        <td className="px-3 py-4  text-center text-sm font-medium whitespace-nowrap sm:pr-6 gap-2">

                          <button
                            type="button"
                            className=" rounded bg-white px-5 py-2 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-100"

                            onClick={() =>
                              handleClickForView(person)
                            }
                          >
                            View
                          </button>

                          <button
                            type="button"
                            className=" rounded bg-white px-5 py-2  ml-2 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-100"

                            onClick={() =>
                              handleClickForEdit(person)
                            }
                          >
                            Edit
                          </button>
                          <button
                            type="button"
                            className="rounded bg-white px-5 py-2 text-sm ml-2 font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-100"

                            onClick={() =>
                              Delete(person.id)
                            }

                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {paginationData && (
        <Pagination
          links={paginationData.links}
          currentPage={paginationData.current_page}
          totalResults={paginationData.total}
          from={paginationData.from}
          to={paginationData.to}
          lastPage={paginationData.last_page}
          onPageChange={handlePageChange}
        />
      )}

      <Transition.Root show={activePlanCreateOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => { }}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-90 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8   md:max-w-screen-md lg:max-w-screen-lg sm:w-full">
                  <div>
                    <ActivePlanCreate
                      close={handleClose}
                    // closeModal={closeModal}
                    />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      {/*Modal Edit */}
      <Transition.Root show={activePlanEditOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => { }}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-90 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8   md:max-w-screen-md lg:max-w-screen-lg sm:w-full">
                  <div>
                    <ActivePlanEdit
                      close={handleClose}
                      activePlan={activePlanId}

                    />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      {/* Modal Edit*/}


      <Transition.Root show={activePlanDelete} as={Fragment}>
        <Dialog
          as="div"
          className="fixed z-10 inset-0 overflow-y-auto"
          onClose={() => setActivePlanDelete(false)}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                  <button
                    type="button"
                    className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    onClick={() => {
                      setActivePlanDelete(false);
                      setDeleteMsg(
                        "Are you sure you want to delete the Delete Active Plan ?"
                      );
                    }}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>
                <div className="sm:flex sm:items-start">
                  <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                    <ExclamationCircleIcon
                      className="h-6 w-6 text-red-600"
                      aria-hidden="true"
                    />
                  </div>
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <Dialog.Title
                      as="h3"
                      className="text-lg leading-6 font-medium text-gray-900"
                    >
                      Delete Active Plan
                    </Dialog.Title>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">{deleteMsg}</p>
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                  <button
                    type="button"
                    className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                    onClick={handleClickForDelete}
                  >
                    Delete
                  </button>
                  <button
                    type="button"
                    className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
                    onClick={() => setActivePlanDelete(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>

      <Transition.Root show={activePlanViewOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => { }}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-90 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8   md:max-w-screen-md lg:max-w-screen-lg sm:w-full">
                  <div>
                    <ActivePlanView
                      close={handleClose}
                      activePlan={activePlanId}

                    />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

    </div>
  )
}

export default ActivePlanList
